import {Ticket} from "../components";
import Layout from "../components/Layout";

export default function Score() {

  return (
    <div>
        <Layout />
        <div>
            <Ticket />
        </div>
    </div>
  );
}